import { render } from "./Main.vue?vue&type=template&id=d950d774&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=d950d774&scoped=true&lang=css"

import exportComponent from "/Users/programmer2/Desktop/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d950d774"]])

export default __exports__